import React, { Component, Fragment } from 'react';
import { do_action } from '../../actions';
import {getFloor, convertPrice, convertPriceNumber, formartDate, calculatorPriceItem, convertPriceToNumber, getTimePDF} from '../../utils/convert'
import {BASE_URL_ADMIN} from '../../data/config'
import ModalUpdatePriceItemQuote from '../Modal/ModalUpdatePriceItemQuote'
import ModalAddItemQuote from '../Modal/ModalAddItemQuote'

class QuoteContractorDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            allRoomQuote: [],
            total_price: 0,
            dataPriceItems: {},
            dataAreaItems: {},
            dataDimension: {},
            quote: '',
            itemEdit: '',
            priceItemContractor: {},
            priceItemEdit: {},
            room_idx: 0,
            itemIdx: 0,
            nb_add: 1,
            roomAdd: '',
            house_type: ''
        }
    }

    componentWillMount() {
        do_action('get_contractor_quote_detail', { quote: this.props.quote, contractor: this.props.vendor._id })
            .then(response => {
                if (response.signal) {
                    let dataQuotesContractor = response.data;
                    let {allRoomQuote, total_price, dataPriceItems, dataAreaItems, quote, priceItemContractor, priceItemEdit, dataItemAdd, dataDimension, dataItemRemove} = dataQuotesContractor;
                    
                    dataItemRemove = dataItemRemove || {}

                    allRoomQuote = allRoomQuote.map(room => {
                        let { items } = room
                        items = items.map((it, idx) => {
                            let imageUrl = (it.items.image_path) ? BASE_URL_ADMIN + '/uploads/' + it.items.image_path : '/images/re1.png';
                            let price = dataPriceItems[it._id] || 0;
                            let areas = dataAreaItems[it._id] || '';
                            let dm = dataDimension[it._id] || {}
                            it.url = imageUrl
                            it.quantity_area = areas
                            it.dm = dm
                            let price_unit = calculatorPriceItem(priceItemEdit, priceItemContractor, it.items, it.area_items_id, it.quote_room_id._id)
                            it.price_unit = price_unit
                            it.total_price = price
                            return it
                        })

                        let itemAdd = dataItemAdd[room.room._id] || []
                        itemAdd = itemAdd.map(its => {
                            let imageUrl = (its.image_path) ? BASE_URL_ADMIN + '/uploads/' + its.image_path : '/images/re1.png';
                            let itemData = Object.assign({}, its);
                            let price = its.quantity * its.price
                            let areas = its.quantity + ' ' + its.type_price
                            itemData.url = imageUrl
                            itemData.quantity_area = areas
                            itemData.dm = {
                                quantity: its.quantity,
                                type: its.type_price,
                                value: 1,
                                dm: areas
                            }
                            let price_unit = { price: its.price, type_item: 2 }
                            itemData.price_unit = price_unit
                            itemData.total_price = price.toFixed(2)
                            itemData.items = its;

                            return itemData
                        })

                        room.items = items.concat(itemAdd)
                        return room
                    })

                    this.setState({
                        allRoomQuote,
                        total_price,
                        dataPriceItems,
                        dataAreaItems,
                        quote,
                        house_type: quote.house_type,
                        priceItemContractor,
                        priceItemEdit
                    })

                }
            })
    }

    openModalUpdateItem(item, itemIdx, room_idx, e) {
        e.preventDefault()
        let $ = window.$
        this.setState({
            itemEdit: item,
            room_idx,
            itemIdx
        })
        $('#modal-update-item-quotes').modal('show')
    }

    openModalAddItem(rooms, e) {
        e.preventDefault()
        let { nb_add } = this.state
        let $ = window.$
        this.setState({
            roomAdd: rooms,
            nb_add: nb_add + 1
        })
        $('#modal-add-item-quotes').modal('show')
    }

    nextItem() {
        let { itemIdx, room_idx, allRoomQuote } = this.state
        let quoteRoom = allRoomQuote[room_idx]
        if (!quoteRoom) return

        let { items } = quoteRoom
        let numberIt = items.length
        let numberRoom = allRoomQuote.length

        if (itemIdx + 1 < numberIt)
            this.setState({
                itemEdit: items[itemIdx + 1],
                itemIdx: itemIdx + 1
            })
        else if (room_idx + 1 < numberRoom)
            this.setState({
                itemEdit: allRoomQuote[room_idx + 1].items[0],
                itemIdx: 0,
                room_idx: room_idx + 1
            })

        else
            this.setState({
                itemEdit: allRoomQuote[0].items[0],
                itemIdx: 0,
                room_idx: 0
            })
    }

    addItems(data) {
        let { roomAdd, new_total_price } = data
        let { allRoomQuote } = this.state

        allRoomQuote = allRoomQuote.map(room => {
            if (room.room._id == roomAdd.room._id) {
                return roomAdd
            } else {
                return room
            }
        })

        this.setState(prevState => ({
            total_price: new_total_price,
            allRoomQuote
        }))
    }

    updatePrice(data) {
        let {priceItemContractor, dataPriceItems, room_idx, itemIdx, allRoomQuote} = this.state
        let {price, item_id, new_total_price, item_quote, new_price, type_item, area_items_id, quote_room_id} = data

        allRoomQuote = allRoomQuote.map((room, idx) => {
            if (idx == room_idx) {
                let { items } = room
                items = items.map((it, it_idx) => {
                    if (it_idx == itemIdx) {
                        it.price_unit = { price: price, type_item }
                        it.total_price = new_price
                    }

                    return it
                })

                room.items = items
                return room
            } else {
                return room
            }
        })

        this.setState(prevState => ({
            total_price: new_total_price,
            allRoomQuote,
            priceItemEdit: Object.assign(prevState.priceItemEdit, {[`${area_items_id}_${quote_room_id}`] : {price, type_item}}),
            dataPriceItems: Object.assign(prevState.dataPriceItems, {[item_quote] : new_price})
        }))
    }

    // printQuotes() {
    //     var pwa = window.open("", "_new");
    //     pwa.document.open();
    //     pwa.document.write(this.pageToPrint());
    //     pwa.document.close();
    // }

    // pageToPrint() {
    //     let {vendor} = this.props
    //     let {total_price, quote} = this.state
    //     if (!quote) return ''

    //     let {customer} = quote
    //     customer = customer || {first_name: '', last_name: '', phone: '', address:'', city: ''}
    //     let contentItem = this.getContentPrint()
    //     let windowContent =
    //         `<!DOCTYPE html>
    //         <html lang="en">
            
    //         <head>
    //             <meta charset="utf-8">
    //             <meta http-equiv="X-UA-Compatible" content="IE=edge">
    //             <meta name="viewport" content="width=device-width, initial-scale=1">
    //             <title>Quote detail</title>
    //             <style>
    //             @media print {
    //                 @page {
    //                     margin: 0 auto; /* imprtant to logo margin */
    //                     sheet-size: 80mm 250mm; /* imprtant to set paper size */
    //                 }
    //                 html,body{margin:0;padding:0;}
    //                 #printContainer {
    //                     width: 230px;
    //                     margin: auto;
    //                     padding: 5px;
    //                     text-align: justify;
    //                     font-family: GillSansStd;
    //                 }
    //                 #logo{
    //                     margin: 0 5px;
        
    //                 }
        
    //                 .tr-special {
    //                     background: transparent !important;
    //                     border: none !important;
    //                 }
    //                 .tr-special .all-price {
    //                     padding: 4px 4px;
    //                     border-top: 1px solid #ccc;
    //                     border-bottom: 1px solid #ccc;
    //                 }
    //                 .text-red {
    //                     color: red;
    //                 }
        
    //                 .printChild { page-break-after: always; }
        
    //                 .text-center{text-align: center;}
    //                 .text-right{text-align: right;}
    //                 .text-left{text-align: left;}
    //             }
    //                 .marginB5 { margin-bottom: 5px; }
            
    //                 .border-top { border-top: 1px solid #ccc; }
            
    //                 .text-underline { text-decoration: underline; }
            
    //                 .text-red { color: red; }
            
    //                 .header { padding: 30px 0 0 0; }
    //                 .header .sub-logo { color: #a2a2a2; font-size: 12px; margin: 10px 0 0 0; }
    //                 .header .address { font-size: 13px; color: red; border-bottom: 2px solid #ababab; padding-bottom: 10px; margin-bottom: 10px; }
            
    //                 .attn { display: inline-block; width: 100px; }
            
    //                 .tr-special { background: transparent !important; border: none !important; }
    //                 .tr-special td { border: none !important; padding-top: 25px !important; }
    //                 .tr-special .all-price { padding: 4px 4px; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; }
            
    //                 .table-kentrung { border: none; border-top: 1px solid #ccc; }
        
    //                 p {
    //                     margin: 0 0 10px;
    //                 }
                    
    //                 .container {
    //                     padding-right: 15px;
    //                     padding-left: 15px;
    //                     margin-right: auto;
    //                     margin-left: auto;
    //                     width: 1050px;
    //                 }
                    
    //                 .text-center {
    //                     text-align: center;
    //                 }
                    
    //                 .row {
    //                     margin-right: -15px;
    //                     margin-left: -15px;
    //                 }
                    
    //                 .table-bordered {
    //                     border: 1px solid #ddd;
    //                 }
            
    //                 .table {
    //                     width: 100%;
    //                     max-width: 100%;
    //                     margin-bottom: 20px;
    //                 }
    //                 table {
    //                     background-color: transparent;
    //                 }
    //                 table {
    //                     border-spacing: 0;
    //                     border-collapse: collapse;
    //                 }
                    
    //                 .text-right {
    //                     text-align: right;
    //                 }
                    
    //                 .col-lg-4 {
    //                     width: 33.33333333%;
    //                 }
                    
    //                 .col-lg-push-4 {
    //                     left: 33.33333333%;
    //                 }
                    
    //                 * {
    //                     -webkit-box-sizing: border-box;
    //                     -moz-box-sizing: border-box;
    //                     box-sizing: border-box;
    //                 }
                    
    //                 .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9 {
    //                     float: left;
    //                 }
                    
    //                 .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
    //                     position: relative;
    //                     min-height: 1px;
    //                     padding-right: 15px;
    //                     padding-left: 15px;
    //                 }
                    
    //                 .table>caption+thead>tr:first-child>td, .table>caption+thead>tr:first-child>th, .table>colgroup+thead>tr:first-child>td, .table>colgroup+thead>tr:first-child>th, .table>thead:first-child>tr:first-child>td, .table>thead:first-child>tr:first-child>th {
    //                     border-top: 0;
    //                 }
            
    //                 .table-bordered>thead>tr>td, .table-bordered>thead>tr>th {
    //                     border-bottom-width: 2px;
    //                 }
    //                 .table-bordered>tbody>tr>td, .table-bordered>tbody>tr>th, .table-bordered>tfoot>tr>td, .table-bordered>tfoot>tr>th, .table-bordered>thead>tr>td, .table-bordered>thead>tr>th {
    //                     border: 1px solid #ddd;
    //                 }
                    
    //                 .table-striped>tbody>tr:nth-of-type(odd) {
    //                     background-color: #f9f9f9;
    //                 }
                    
    //                 .table>thead>tr>th {
    //                     vertical-align: bottom;
    //                     border-bottom: 2px solid #ddd;
    //                 }
    //                 .table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
    //                     padding: 8px;
    //                     line-height: 1.42857143;
    //                     vertical-align: top;
    //                     border-top: 1px solid #ddd;
    //                     font-size: 13px;
    //                 }
    //                 th {
    //                     text-align: left;
    //                 }
    //                 .container:after,.container:before,.row:after,.row:before {
    //                     display: table;
    //                     content: " ";
    //                 }
    //                 .btn-group-vertical>.btn-group:after, .btn-toolbar:after, .clearfix:after, .container-fluid:after, .container:after, .dl-horizontal dd:after, .form-horizontal .form-group:after, .modal-footer:after, .modal-header:after, .nav:after, .navbar-collapse:after, .navbar-header:after, .navbar:after, .pager:after, .panel-body:after, .row:after {
    //                     clear: both;
    //                 }
    //                 .tr-special {
    //                     background: transparent !important;
    //                     border: none !important;
    //                 }
    //                 .tr-special .all-price {
    //                     padding: 4px 4px;
    //                     border-top: 1px solid #ccc;
    //                     border-bottom: 1px solid #ccc;
    //                 }
    //                 .text-red {
    //                     color: red;
    //                 }
        
    //             </style>
    //         </head>
            
    //         <body onload="window.print();">
    //             <div class="printContainer printChild">
    //             <div class="header">
    //                 <div class="container">
    //                     <div class="logo text-center">
    //                         <a href="#">
    //                             <img src="/images/logo_vendor.png" alt="">
    //                         </a>
    //                     </div>
    //                     <div class="sub-logo text-center">109 Jalan Besar Singapore 208829 &nbsp; Tel: +65 63980900 &nbsp; Fax: +6563980700</div>
    //                     <div class="text-center address">www.jsrdesign.com.sg</div>
    //                 </div>
    //             </div>
    //             <div class="container" style="min-height: 30cm">
    //                 <div class="row">
    //                     <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
    //                         <div>
    //                             <span class="attn">Attn</span>
    //                             <span>${customer.first_name} ${customer.last_name}</span>
    //                         </div>
    //                         <div>
    //                             <span class="attn">Address</span>
    //                             <span>${customer.address} ${customer.city}</span>
    //                         </div>
    //                     </div>
    //                     <div class="col-xs-12 col-sm-12 col-md-4 col-md-push-4 col-lg-4 col-lg-push-4">
    //                         <div>
    //                             <span class="attn">Date</span>
    //                             <span>${getTimePDF()}</span>
    //                         </div>
    //                         <div>
    //                             <span class="attn">Telephone</span>
    //                             <span>${customer.phone}</span>
    //                         </div>
    //                         <div>
    //                             <span class="attn">Ref No</span>
    //                             <span></span>
    //                         </div>
    //                         <div>
    //                             <span class="attn">NRIC</span>
    //                             <span></span>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 <div class="marginB5">Email</div>
    //                 <div class="marginB5"><strong>Dear Sir / Madam</strong></div>
    //                 <div class="marginB5"><strong class="text-underline">QUOTATION FOR INTERIOR RENOVATION WORK -  PART 1</strong></div>
    //                 <br>
    //                 <table class="table table-bordered table-hover table-striped">
    //                     <thead>
    //                         <tr>
    //                             <th class="text-center">S/N</th>
    //                             <th>Work Description</th>
    //                             <th class="text-center">Qty Units</th>
    //                             <th class="text-right">Amount</th>
    //                         </tr>
    //                     </thead>
    //                     <tbody>
    //                         ${contentItem}
    //                         <tr class="tr-special" style="background: transparent !important;border: none !important;">
    //                             <td class="text-center">&nbsp;</td>
    //                             <td>
    //                                 <p><strong>Grand Total Amount (After discount)</strong></p>
    //                                 <div>Dollars: ${convertPriceToNumber(total_price)}</div>
    //                             </td>
    //                             <td class="text-center"></td>
    //                             <td class="text-right"><strong class="all-price">$${convertPriceNumber(total_price)}</strong></td>
    //                         </tr>
    //                     </tbody>
    //                 </table>
    //                 <br>
    //                 <br>
    //                 <br>
    //             </div>
    //             <div class=" container">
    //                 <div class="row">
    //                     <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
    //                         <div><strong>Yours Sincerely, for ${vendor.detail.name}</strong></div>
    //                         <br>
    //                         <br>
    //                         <br>
    //                         <div class="border-top marginB5"></div>
    //                         <div><strong>Ron Foo (Mobile: 96721804)</strong></div>
    //                         <div><strong>Creative Director</strong></div>
    //                     </div>
    //                     <div class="col-xs-12 col-sm-12 col-md-4 col-md-push-4 col-lg-4 col-lg-push-4">
    //                         <div class="text-center"><strong>Agreed & Accepted by:</strong></div>
    //                         <br>
    //                         <br>
    //                         <br>
    //                         <div class="border-top marginB5"></div>
    //                         <div class="text-center"><strong>${customer.first_name} ${customer.last_name}</strong></div>
    //                     </div>
    //                 </div>
    //             </div>
    //             </div>
    //         </body>
            
    //         </html>`

    //     return windowContent
    // }

    getContentItemRoom(listItems, nb_idx) {
        let {quoteState} = this.props
        let {dataPriceItems, dataAreaItems} = this.state;
        return listItems.map((items, idx) => {
            return `
            <tr>
                <th class="text-center">${idx + nb_idx}</th>
                <td>${items.items.title}</td>
                <td class="text-center">${items.quantity_area}</td>
                <td class="text-right">$${convertPrice(items.total_price)}</td>
            </tr>
            `
        });
    }

    getContentPrint() {
        let { allRoomQuote } = this.state;
        let numberIt = 1
        return allRoomQuote.map((roomQuote, idx) => {
            let nb = roomQuote.items.length
            let nb_idx = numberIt
            numberIt += nb;
            return `<tr>
                    <td style="border-right: none !important;"></td>
                    <td colspan="3" style="border-left: none !important;"><strong>${roomQuote.room.rooms.name}</strong></td>
                </tr>
                ${this.getContentItemRoom(roomQuote.items, nb_idx)}`
        });
    }

    renderQuotesRoom() {
        let { allRoomQuote } = this.state;
        return allRoomQuote.map((roomQuote, idx) => {
            return (
                <div className="block-room" key={`rooms-${idx}`}>
                    <div className="clearfix panen-heading">
                        <div className="pull-left">
                            <div className="big-title">{`${roomQuote.room.rooms.name} - Floor ${getFloor(roomQuote.room.floor)}`}</div>
                        </div>

                        {this.props.quoteState == 0 && (
                            <div className="pull-right" onClick={this.openModalAddItem.bind(this, roomQuote)}>
                                <a href="#" className="bg-blue select">
                                    <span className="fa fa-plus"></span>
                                </a>
                            </div>
                        )}
                        
                    </div>
                    <div className="panen-body">
                        {this.renderItemRoom(roomQuote.items, idx)}
                    </div>
                </div>
            );
        });
    }

    renderItemRoom(listItems, room_idx) {
        let {quoteState} = this.props
        let {dataPriceItems, dataAreaItems} = this.state;
        return listItems.map((items, idx) => {
            return (
                <div className={`mqd-popup clearfix ${items.price_unit.type_item ? 'bg-warning' : ''}`} key={`items-${idx}`}>
                    <div className="pull-left img">
                        <img src={items.url} alt="" className="img-responsive" />
                    </div>
                    <div className="pull-right">
                        <span className="text-primary-kt price mr-10">{`$${convertPrice(items.total_price)}`}</span>
                        {quoteState == 0 && (
                            <a href="#" onClick={this.openModalUpdateItem.bind(this, items, idx, room_idx)}><i className="fa fa-edit"></i></a>
                        )}
                        
                    </div>
                    <div className="info">
                        <a href="#" className="name">{items.items.title}</a>
                        {items.dm.type == 'lot' ? (
                            <div className="sub">{items.quantity_area}</div>
                        ) : (
                            <Fragment>
                                <div className="sub">{`${items.dm.quantity} items`}</div>
                                <div className="sub">Dimension: {items.dm.dm}</div>
                            </Fragment>
                        )}
                        
                    </div>
                </div>
            );
        });
    }

    render() {
        let { itemEdit, total_price, nb_add, roomAdd, house_type } = this.state;
        return (
            <div>

                {this.renderQuotesRoom()}

                <ModalUpdatePriceItemQuote
                    itemEdit={itemEdit}
                    vendor={this.props.vendor}
                    total_price={total_price}
                    updatePrice={this.updatePrice.bind(this)}
                    nextItem={this.nextItem.bind(this)}
                />

                <ModalAddItemQuote
                    vendor={this.props.vendor}
                    total_price={total_price}
                    nb_add={nb_add}
                    roomAdd={roomAdd}
                    house_type={house_type}
                    addItems={this.addItems.bind(this)}
                />
                
            </div>
        );
    }
}

export default QuoteContractorDetail;